import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3466c610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sider-view" }
const _hoisted_2 = { class: "sider-view-menu" }
const _hoisted_3 = { class: "sider-view-foot" }
const _hoisted_4 = { class: "sider-view-foot-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiderMenu = _resolveComponent("SiderMenu")!
  const _component_MenuUnfoldOutlined = _resolveComponent("MenuUnfoldOutlined")!
  const _component_MenuFoldOutlined = _resolveComponent("MenuFoldOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SiderMenu, {
        mode: "inline",
        theme: "dark",
        menu: _ctx.menuList,
        selectedKeys: _ctx.menu.current,
        collapsed: _ctx.menu.collapsed,
        onSelect: _ctx.onSelect
      }, null, 8, ["menu", "selectedKeys", "collapsed", "onSelect"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-bottom":"16px"},
          onClick: _ctx.toggleCollapsed
        }, {
          default: _withCtx(() => [
            (_ctx.menu.collapsed)
              ? (_openBlock(), _createBlock(_component_MenuUnfoldOutlined, { key: 0 }))
              : (_openBlock(), _createBlock(_component_MenuFoldOutlined, { key: 1 }))
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}